import { ACCOUNTTRANSACTIONS_STATES } from "./AccountTransactions.constants";

const initialState = {
  status: ACCOUNTTRANSACTIONS_STATES.idle,
  data: [],
  account: null,
  token: null,
  total: null,
  dateRange: [],
  error: null,
};

const AccountTransactions = (
  state = initialState,
  action: {
    type: string;
    transactions: any[];
    account: string;
    token: string;
    dateRange: any[];
    total: number;
    error: any;
  }
) => {
  switch (action.type) {
    case "GET_ACCOUNTTRANSACTIONS":
      return {
        ...state,
        status: ACCOUNTTRANSACTIONS_STATES.loading,
        data: [],
        account: action.account,
        token: action.token,
        dateRange: action.dateRange,
        error: null,
      };
    case "GET_ACCOUNTTRANSACTIONS_SUCCESS":
      return {
        ...state,
        status: ACCOUNTTRANSACTIONS_STATES.success,
        data: action.transactions,
        total: action.total,
        error: null,
      };
    case "GET_ACCOUNTTRANSACTIONS_FAILURE":
      return {
        ...state,
        status: ACCOUNTTRANSACTIONS_STATES.failure,
        data: [],
        total: null,
        error: action.error,
      };
    default:
      return state;
  }
};

export default AccountTransactions;
